import { render, staticRenderFns } from "./SecondaryMenuSubMenu.vue?vue&type=template&id=3c46747e"
import script from "./SecondaryMenuSubMenu.vue?vue&type=script&lang=js"
export * from "./SecondaryMenuSubMenu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports